export default __webpack_public_path__ + "static/artDepartment-ee352061f85da985309fb264f134784f.png";